import { encrypt } from "eth-sig-util";
import { bufferToHex } from "ethereumjs-util";
import { Encryption } from "../types/Encryption";

function encryptData({ encryptionPublicKey, data }: Encryption): string {
  const encryptedMessage = bufferToHex(
    Buffer.from(
      JSON.stringify(encrypt(encryptionPublicKey, { data }, "x25519-xsalsa20-poly1305")),
      "utf8",
    ),
  );
  return encryptedMessage;
}

export default encryptData;
